import { ControlValueAccessor, NgControl } from '@angular/forms';
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  Optional,
  Self,
  SimpleChanges,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() content;
  @Input() checked;
  @Input() disabled = false;
  @Output() selectionChanged = new EventEmitter();
  @Input() class;
  @Input() errorMessage?= '';
  @Input() color: 'accent' | 'primary' | 'warn' = 'primary';
  isChecked = false;
  _errorStatus: Boolean = false;

  constructor(@Optional() @Self() private ngControl: NgControl) {
    if (ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.ngControl) {
      // Initialize from form control value if available
      // Angular Forms will also call writeValue automatically, but we need to handle
      // the case where the value is set before the component is fully initialized
      if (this.ngControl.control?.value !== undefined && this.ngControl.control?.value !== null) {
        this.writeValue(this.ngControl.control.value);
      }

      this.ngControl.control.statusChanges.subscribe((formStatus) => {
        if (
          formStatus === 'INVALID' &&
          this.ngControl.errors &&
          (this.ngControl.dirty || this.ngControl.touched)
        ) {
          this._errorStatus = true;
          this.class = 'error';
        } else {
          this._errorStatus = false;
          this.class = '';
        }
      });
    } else if (this.checked !== undefined) {
      // If not using form control, use @Input() checked
      this.writeValue(this.checked);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update isChecked when @Input() checked changes (only if not using form control)
    if (changes['checked'] && !this.ngControl && changes['checked'].currentValue !== undefined) {
      this.writeValue(changes['checked'].currentValue);
    }
  }

  get value() {
    return this.isChecked;
  }

  set value(val) {
    if (val !== undefined) {
      this.isChecked = val;
      this.propagateChange(this.isChecked);
    }
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.isChecked = value;
    }
  }

  propagateChange = (_: any) => { };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }

  checkChanged(event: MatCheckboxChange): void {
    this.isChecked = event.checked;
    this.propagateChange(this.isChecked);
    this.selectionChanged.emit(event.checked);
  }
}